import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  input,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {ActivitiesMapEventListener, ActivitiesMapWidget} from "../../lib/activities-map-widget";
import {ComuneDTO} from "../../models/comune.model";
import {UserService} from "../../services/user.service";
import {SostegniService} from "../../services/sostegni.service";
import {NominatimService} from "../../services/nominatim.service";
import {ComuniService} from "../../services/comuni.service";
import {ComuneMappa} from "../../models/territori_api";
import {getAverageLonLatSostegni, Sostegno} from "../../models/sostegno.models";
import {AutoCompleteCompleteEvent, AutoCompleteSelectEvent} from "primeng/autocomplete";
import {NominatimResponse} from "../../models/nominatim/response.model";
import {Coordinate} from "../../models/coordinate.model";
import {PosizioneSegnalazione} from "../../models/posizione-segnalazione";
import {QuadriService} from "../../services/quadri.service";
import {QuadroElettrico} from "../../models/quadro.model";
import { EdificiService } from 'src/app/services/edifici.service';
import { take } from 'rxjs/internal/operators/take';
import { Edificio } from 'src/app/models/edificio.model';
import { forkJoin, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-localize-issue-activity-widget',
  standalone: false,
  templateUrl: './localize-issue-activity-widget.component.html',
  styleUrl: './localize-issue-activity-widget.component.scss'
})
export class LocalizeIssueActivityWidgetComponent implements OnInit, OnChanges {
  @Input({required: true}) comune: ComuneDTO;
  @Input({required: false}) srcPosition: PosizioneSegnalazione;
  @Input({required: false}) showSostegni: boolean;
  @Output() onPositionUpdate = new EventEmitter<PosizioneSegnalazione>();

  @Input({required: false}) controlsMaximize: boolean = true;
  @Input({required: false}) controlsMyPosition: boolean = true;
  @Input({required: false}) controlsFullExtent: boolean = true;
  @Input({ required: false}) readonly: boolean = false;

  areaCompetenza = input<string>();

  edificiService = inject(EdificiService);

  static COMPONENTID = 0;

  isReady: boolean;
  componentDivId: string;

  mapwidget: ActivitiesMapWidget;
  maplistener: ActivitiesMapEventListener;


  territories: ComuneMappa[];
  sostegni: Sostegno[];
  quadri: QuadroElettrico[];
  edifici: Edificio[];

  idSostegni: string[];
  selezioneSostegni: string[];
  searchSostegno: string;

  activeBackground: string;
  bgSelect: {
    name: string,
    layer: any
  }[];

  filteredIndirizzi: any[];

  // this is used for output ONLY
  selectdPosition: PosizioneSegnalazione;

  selSostegni: string[];
  selIndirizzo: string;
  selCoordinates: Coordinate;
  selEdifici: Edificio[];

  // indirizzo_civico: string;
  indirizzo_base: {
    indirizzo: string;
    latitudine: number;
    longitudine: number;
  };

  @ViewChild('widgetHolder') widgetHolder: ElementRef;

  constructor(private userService: UserService, private sostegniService: SostegniService, private quadriService: QuadriService, private nominatimService: NominatimService, private comuniService: ComuniService) {
    this.territories = null;
    this.sostegni = null;
    this.quadri = null;
    this.idSostegni = [];
    this.selSostegni = [];

    this.componentDivId = LocalizeIssueActivityWidgetComponent.getComponentId();
    this.bgSelect = [];
    this.activeBackground = null;

    const compo = this;
    this.maplistener = new class extends ActivitiesMapEventListener {
      onSelectSostegno(sostegno: Sostegno) {
        if (!compo.readonly) {
          compo.togglePositionSostegno(sostegno);
        }
      }

      onSelectPosizione(lonlat: number[]) {
        if (!compo.readonly) {
          compo.updatePositionFromMapLonLat(lonlat);
        }
      }

      onSelectEdificio(edificio: Edificio): void {
        if (!compo.readonly) {
          compo.togglePositionEdificio(edificio);
        }
      }

      onLayersChange() {
        super.onLayersChange();
        // console.log("layers changed to ", compo.mapwidget.bglayers);
        compo.updateBackgroundSelect();
      }


    }();

    // console.log("position reset in constructor");
    this.selectdPosition = {
      sostegni: [],
      coordinates: null,
      indirizzo: null
    };
  }

  changeBackgroundLayer(layername: string) {
    this.mapwidget.setBgLayerByName(layername);
  }


  updateBackgroundSelect() {
    this.bgSelect = this.mapwidget.bglayers.map((item) => {
      return {
        name: item.get("name"),
        layer: item
      }
    });
    this.activeBackground = this.mapwidget.backgroundLayer.get("name");
  }


  static getComponentId (): string {
    const out = LocalizeIssueActivityWidgetComponent.COMPONENTID;
    LocalizeIssueActivityWidgetComponent.COMPONENTID++;
    return "locact_mapholder_" + out;
  }


  checkUpdateReadiness () {
    // console.log("checking mapwidget readiness from ", this.isReady);
    if (!this.isReady) {
      // console.log("updating mapwidget readiness?");
      if (this.territories != null && this.sostegni != null && this.quadri != null) {
        // console.log("loaded territories ", this.territories, "sostegni ", this.sostegni);
        this.isReady = true;
        this.onReady();
      }
    }
  }

  ngOnInit() {
    //TODO: rivedere la logica di questo widget.

    // console.log("oninit mw", this.comune, "w pos", this.srcPosition);
    const territories$ = this.loadTerritories();
    let quadri$ = of([]);
    let edifici$ = of([]);
    let sostegni$ = of([]);
    //TODO: meglio un enum di queste magic strings o una costante condivisa con il backend
    if (this.areaCompetenza() == "PUBBLICA" || this.areaCompetenza() == "SEMAFORO") {
      quadri$ = this.loadQuadri(this.comune.denominazione);
    } else if (this.areaCompetenza() == "CALORE") {
      edifici$ = this.loadEdifici();
    }

    if (this.comune) {
      sostegni$ = this.loadSostegni();
    }

    //TODO: se una di queste chiamate va in errore tutte vanno in errore, va bene??
    forkJoin({
      territories: territories$,
      quadri: quadri$,
      edifici: edifici$,
      sostegni: sostegni$
    }).subscribe(({ territories, quadri, edifici, sostegni }) => {
      // Questo codice viene eseguito SOLO quando l'ultima chiamata ha risposto
      this.territories = territories;
      this.quadri = quadri;
      this.edifici = edifici;
      this.sostegni = sostegni;
      this.idSostegni = this.sostegni.map((sostegno) => { return sostegno.codice});
      this.checkUpdateReadiness();
    });

  }

  ngOnChanges (changes: SimpleChanges) {
    // console.log("incoming position is ", this.srcPosition);
    // console.log("changes on: ", changes);
    const edificLengthChange = changes["srcPosition"]?.currentValue?.edifici?.length != changes["srcPosition"]?.previousValue?.edifici?.length;
    if (changes["srcPosition"] && !edificLengthChange) {
      this.setForcePosition(this.srcPosition);
    }

  }

  onReady () {
    // console.log("creating map widget");
    this.mapwidget = new ActivitiesMapWidget(this.territories, this.sostegni, this.quadri, !this.readonly);
    this.mapwidget.setEdifici(this.edifici);
    this.mapwidget.initMap(this.componentDivId);
    this.mapwidget.showOnlyActiveSostegni = this.readonly;
    // console.log("map init done");
    this.mapwidget.sostegniLayer.setVisible(this.showSostegni);
    // console.log("setting map to fit data");
    this.mapwidget.fitToData();
    // console.log("adding listener");
    this.mapwidget.addListener(this.maplistener);

    if (this.srcPosition) {
      this.selectdPosition = {...this.srcPosition};
      // console.log("setting position to ", this.srcPosition);
      this.setForcePosition(this.srcPosition);
      this.mapwidget.applyPosition(this.srcPosition);
    }

    this.updateBackgroundSelect();
  }


  filterSostegni (event: AutoCompleteCompleteEvent) {
    const queryval = event.query;
    this.idSostegni = this.sostegni.map((sostegno) => { return sostegno.codice}).filter((id) => {
      return id.toLowerCase().includes(queryval.toLowerCase());
    });
  }

  findSostegno () {
    const selected = this.sostegni.find((sostegno) => { return sostegno.codice == this.searchSostegno});
    // console.log("selected", this.selezioneSostegno, selected);
    this.mapwidget.positionToSostegno(selected.codice);
    this.mapwidget.selectElementSostegno(selected.codice);
    // this.setLocFromSostegnoOnMap(selected);

  }

  loadTerritories(): Observable<ComuneMappa[]> {
    return this.comuniService.getComuniMappa().pipe(
      take(1),
      map((data: ComuneMappa[]) => {
        if (this.userService.isSegnalatore) {
          const userIstat = this.userService.getUser().comune.codiceIstat;
          return data.filter((comune) => comune.codiceISTAT == userIstat);
        } else if (this.comune) {
          return data.filter((comune) => comune.codiceISTAT == this.comune.codiceIstat);
        }
        return data;
    }));
  }

  loadQuadri(comune: string): Observable<QuadroElettrico[]> {
    return this.quadriService.getByComune(comune).pipe(take(1));
  }

  loadSostegni(): Observable<Sostegno[]> {
    return this.sostegniService.getByIDComune(this.comune.id).pipe(take(1));
  }

  private loadEdifici(): Observable<Edificio[]> {
    return this.edificiService.getEdificiByComune(this.comune)
    .pipe(take(1));
  }

  setForcePosition (position: PosizioneSegnalazione) {

    // TODO: need to do things on mapwidget side to reflect this but not trigger more events

    this.selSostegni = [...position.sostegni.map((item) => { return item.codice})];
    this.selCoordinates = {...position.coordinates};
    this.selIndirizzo = position.indirizzo;

    // this.mapwidget.selectElementSostegni(this.selSostegni);
    // this.updatePositionFromMapLonLat([this.srcPosition.coordinates.longitudine, this.srcPosition.coordinates.latitudine]);
    this.mapwidget?.applyPosition(this.selectdPosition);
  }

  geocodificaIndirizzo(event: any){
    const query = event.query;

    this.nominatimService.searchAddress(query, this.comune.denominazione).subscribe((results: NominatimResponse[]) => {
      // console.log("nominatim: ", results);
      this.filteredIndirizzi = results.map(result => ({
        indirizzo: result.display_name.split(',')[0].trim(),
        latitudine: result.lat,
        longitudine: result.lon
      }));
    });
  }

  setPositionFromAddressLonLat (lonlat: number[], indirizzo: string, civico?: string) {

    this.selectdPosition.coordinates = {
      latitudine: lonlat[1],
      longitudine: lonlat[0]
    };
    this.selectdPosition.indirizzo = indirizzo;
    // this.mapwidget.selectActivePosition([...lonlat]);
    this.onPositionUpdate.emit(this.selectdPosition);
  }

  onIndirizzoSelect(event: AutoCompleteSelectEvent) {
    let coordinate:Coordinate = new Coordinate();
    coordinate.latitudine = parseFloat(event.value.latitudine.valueOf());
    coordinate.longitudine = parseFloat(event.value.longitudine.valueOf());
    this.setPositionFromAddressLonLat([coordinate.longitudine, coordinate.latitudine], event.value.indirizzo);
  }


  forcePositionFromCurrentAddress () {
    // console.log("indirizzo main: ", this.indirizzo_base);
/*    if (!!this.indirizzo_base) {
      // const address_number = this.indirizzo_civico?.trim();
      // const posdesc = address_number.length > 0 ? `${this.indirizzo_base.indirizzo} ${address_number}` : this.indirizzo_base.indirizzo;
      this.selectdPosition = {
        postype: "indirizzo",
        posdesc: this.indirizzo_base.indirizzo,
        indirizzo: this.indirizzo_base.indirizzo,
        coordinates: {
          longitudine: this.indirizzo_base.longitudine,
          latitudine: this.indirizzo_base.latitudine
        }
      }
      this.mapwidget.selectActivePosition([this.indirizzo_base.longitudine, this.indirizzo_base.latitudine]);
      this.onPositionUpdate.emit(this.selectdPosition);
    }*/
  }

  updatePositionFromMapLonLat (lonlat: number[]) {
    // this.selezioneSostegno = null;
    // geocode or update if pos is null
    if (lonlat != null) {
      this.nominatimService.reverseGeocode(lonlat[1], lonlat[0]).subscribe((indirizzo) => {
        // const address_long = indirizzo.display_name;
          this.selectdPosition.indirizzo = indirizzo.address?.road ?? null;
          this.selectdPosition.coordinates = {
            longitudine: lonlat[0],
            latitudine: lonlat[1]
          };
          this.onPositionUpdate.emit(this.selectdPosition);
        });
    } else {
      this.selectdPosition.coordinates = null;
      this.selectdPosition.indirizzo = null;
      this.onPositionUpdate.emit(this.selectdPosition);
    }

  }


  togglePositionSostegno (sostegno: Sostegno) {

    const idx = this.selSostegni.indexOf(sostegno.codice);
    if (idx == -1) {
      this.selSostegni.push(sostegno.codice);
    } else {
      this.selSostegni.splice(idx, 1);
    }

    this.selectdPosition.sostegni = this.sostegni.filter((item) => { return this.selSostegni.indexOf(item.codice) != -1 });

    let nominatimEmitted = false;
    // we apply the reverse geocoding ONLY if no coords are set in other ways
    if (this.selCoordinates == null) {
      const centroid = getAverageLonLatSostegni(this.selectdPosition.sostegni);
      if (centroid != null) {
        nominatimEmitted = true;
        this.nominatimService.reverseGeocode(centroid.latitudine, centroid.longitudine).subscribe((indirizzo) => {
          this.selectdPosition.indirizzo = indirizzo.address.road;
          this.selectdPosition.coordinates = {...centroid};
          this.onPositionUpdate.emit(this.selectdPosition);
        });
      }
    }

    if (!nominatimEmitted) {
      this.onPositionUpdate.emit(this.selectdPosition);
    }

    this.mapwidget.toggleSelectElementSostegno(sostegno.codice);
  }

  togglePositionEdificio (edificio: Edificio) {
    if (!this.selEdifici) {
      this.selEdifici = [];
    }
    const idx = this.selEdifici.findIndex((e) => e.gid === edificio.gid);
    if (idx === -1) {
      this.selEdifici.push(edificio);
    } else {
      this.selEdifici.splice(idx, 1);
    }
    this.selectdPosition.edifici = this.selEdifici;
    this.onPositionUpdate.emit(this.selectdPosition);
    this.mapwidget.toggleSelectElementEdificio(edificio.gid);
  }

  centerOnUserLocation () {
    navigator.geolocation.getCurrentPosition((position) => {
      // console.log("position", position.coords.latitude, position.coords.longitude);
      this.mapwidget.centerOnCoords(position.coords.latitude, position.coords.longitude);
    });
  }

  returnToExtent () {
    this.mapwidget.resetView();
  }

  toggleFullscreen () {
    if (this.widgetHolder.nativeElement == document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      this.widgetHolder.nativeElement.requestFullscreen();
    }
  }

}
